const GroupedVerticalLegends = ({ title, groupedItems = {}, stats, isMobile }) => { // Add isMobile
  return (
    <div style={{
      background: 'white',
      padding: isMobile ? '8px' : '12px', // Adjust padding
      borderRadius: '6px',
      boxShadow: '0 0 10px rgba(0,0,0,0.15)',
      maxWidth: isMobile ? '100%' : 280, // Adjust maxWidth
      maxHeight: isMobile ? '200px' : '600px', // Shorter maxHeight for mobile
      overflowY: 'auto',
      fontSize: isMobile ? 11 : 14 // Adjust fontSize
    }}>
      <div style={{ fontWeight: 'bold', marginBottom: isMobile ? 4 : 8 }}>{title}</div>

      {isMobile ? (
        // Simplified mobile view
        Object.entries(groupedItems).map(([general, classes]) => (
          <div key={general} style={{ marginBottom: 8 }}>
            <div style={{ fontWeight: '600', fontSize: isMobile ? 10 : 12, marginBottom: 2 }}>{general}</div>
             {Object.entries(classes).map(([classKey, items]) => (
                <div key={classKey} style={{ display: 'flex', alignItems: 'center', marginBottom: 2, marginLeft: 5}}>
                    <div style={{
                        width: "10px",
                        height: "10px",
                        backgroundColor: items[0].color, // Use first item's color as representative
                        marginRight: "4px",
                        border: "1px solid rgba(0,0,0,0.2)",
                        borderRadius: "2px"
                    }}></div>
                    <span style={{fontSize: isMobile ? 9 : 11}}>{classKey}</span>
                </div>
             ))}
          </div>
        ))
      ) : (
        // Original desktop view
        Object.entries(groupedItems).map(([general, classes]) => (
          <div key={general} style={{ marginBottom: 16 }}>
            <div style={{ fontWeight: '600', marginBottom: 2 }}>{general}</div>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
              {Object.entries(classes).map(([classKey, items]) => {
                const gradient = items.map(i => i.color).join(',');
                return (
                  <div key={classKey} style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: 12, marginBottom: 4, height: '20%' }}>{items[items.length - 1].label}</div>
                  <div style={{
                    width: '18px',
                    height: '120px',
                    background: `linear-gradient(to top, ${gradient})`,
                    border: '1px solid #ccc',
                    borderRadius: 4,
                    margin: '0 auto'
                  }} />
                  <div style={{ fontSize: 12, marginTop: 4 }}>{items[0].label}</div>
                  <div style={{ fontSize: 11, marginTop: '20px' }}>{classKey}</div>
                  </div>
                );
              })}
            </div>
          </div>
        ))
      )}
      {stats && <div style={{ fontSize: isMobile ? 9 : 12, marginTop: isMobile ? 4 : 6 }}>{stats}</div>}
    </div>
  );
};

export default GroupedVerticalLegends;